import { openingAt } from './editing.js';

const finite = (value, min, max) => typeof value === 'number' && Number.isFinite(value) && value >= min && value <= max;

/** Check the exact proposed opening, without moving it to a nearby valid spot.
 * The existing placement helper also protects wall camera supports. */
export function validateOpeningPlacement(plan, proposal) {
  if (!plan || !Array.isArray(plan.walls) || !Array.isArray(plan.openings) || !proposal ||
      !['door', 'window', 'passage'].includes(proposal.kind) ||
      !finite(proposal.along, 0, 100000) || !finite(proposal.width, .2, 100000) ||
      !finite(proposal.height, .2, 100000) ||
      (proposal.kind === 'window' && !finite(proposal.bottom ?? .9, 0, 100000)))
    throw new Error('Enter finite opening dimensions and a valid door, window or passage type.');
  if (plan.openings.filter(item => item.id === proposal.id).length > 1)
    throw new Error('More than one opening has this identity. Review it in Plan checks before editing.');
  const hosts = plan.walls.filter(item => item.id === proposal.wallId);
  if (hosts.length > 1)
    throw new Error('More than one wall has this identity. Review it in Plan checks before editing.');
  const wall = hosts[0];
  if (!wall || wall.objectKind) throw new Error('Choose a real supporting wall on this floor.');
  const length = Math.hypot(wall.x2 - wall.x1, wall.y2 - wall.y1);
  if (!finite(length, .2, 200000) || !finite(wall.h, .2, 100000))
    throw new Error('The supporting wall needs a valid length and height first.');
  const point = { x: wall.x1 + (wall.x2 - wall.x1) * proposal.along / length,
    y: wall.y1 + (wall.y2 - wall.y1) * proposal.along / length };
  const accepted = openingAt(plan, wall, point, proposal.kind, proposal);
  if (!accepted || Math.abs(accepted.along - proposal.along) > 1e-7)
    throw new Error('The opening must fit within its wall with edge clearance, avoid other openings and preserve camera supports.');
  return { wall, opening: { ...accepted, along: proposal.along } };
}
